import { Button, Checkbox, Col, Drawer, Row } from "antd";
import previewImg from "../../Img/config_recetas/config_receta.webp";
import customImg from "../../Img/config_recetas/custom-format.webp";
import "./styles/config_recetas.scss";
import ButtonSingleFile from "../GeneralComponents/buttonSigleFile";
import { useState } from "react";
import { CloseRounded } from "@mui/icons-material";
import { CloseCircleFilled } from "@ant-design/icons";
import TextAreaAntd from "../GeneralComponents/TextAreaAntd";

import headerBg from '../../Img/config_recetas/header-config-receta-0_5x.webp';


export default function NewConfigRecetas({ openDrawer, setOpenDrawer, Firma, setFirma, setMensajeFirma, Logo, setLogo,
    setMensajeLogo, dispatch, showSnackbar, Encabezado, setEncabezado, setMensajeEncabezado, MensajeEncabezado, PiePagina,
    setPiePagina, setMensajePiePagina, MensajePiePagina, loaderSaveConfig, saveConfig, setIsOpenTutorialModal }) {

    const [FirstCheckbox, setFirstCheckbox] = useState(true);
    const [SecondCheckbox, setSecondCheckbox] = useState(false);
    return (
        <Drawer
            closable
            destroyOnClose
            placement="right"
            open={openDrawer}
            onClose={() => {
                setOpenDrawer(false);
                if (localStorage.getItem("statusModalTutoriales") == "true") {
                    setIsOpenTutorialModal(true);
                }
            }}
            closeIcon={<CloseCircleFilled style={{ borderRadius: 360, background: "white", color: "#148f9f", fontSize: "30px" }} />}
            width={'65%'}
            styles={{ content: { padding: "0", margin: "0" }, header: { backgroundImage: `url(${headerBg})`, backgroundSize: 'cover', backgroundRepeat: 'no-repeat' } }}
            title={
                <div className="imgHeader">
                    <div className="text" style={{ display: "flex", alignItems: "center", justifyContent: "left", marginLeft: 40 }}>
                        <h1 style={{ color: "white" }}>Configura tu receta</h1>
                    </div>
                </div>
            }
        >
            <Row>
                <Col sm={{ flex: "50%" }} style={{ alignContent: "center" }}>
                    <h2 style={{ textAlign: "center", color: "#3B7DB2" }}>Ejemplo</h2>
                    <div style={{ display: "flex", justifyContent: "center" }}>
                        {FirstCheckbox && (<img src={previewImg} style={{ height: "60dvh" }} />)}
                        {SecondCheckbox && (<img src={customImg} style={{ height: "60dvh" }} />)}
                    </div>
                </Col>
                <Col sm={{ flex: "50%" }} style={{ display: "flex", alignItems: "center" }}>
                    <div style={{ display: "flex", flexDirection: "column", justifyContent: `${FirstCheckbox ? "space-between" : "center"}`, height: "40dvh", width: "100%", padding: "0 15px" }}>
                        {FirstCheckbox && (
                            <>
                                <TextAreaAntd
                                    label="Encabezado:"
                                    value={Encabezado}
                                    placeholder="Nombre de clinica, hospital, etc."
                                    style={{
                                        marginBottom: ".5%",
                                        fontFamily: "sans-serif",
                                        width: "100%"

                                    }}
                                    columns="30"
                                    autoSize={true}
                                    setStateValue={setEncabezado}
                                    setStateError={setMensajeEncabezado}
                                    valueError={MensajeEncabezado}
                                    textError={["Debe escribir un encabezado"]}
                                    vacio={false}
                                />
                                <TextAreaAntd
                                    label="Pie de pagina:"
                                    value={PiePagina}
                                    placeholder="Direccion, horario, telefono, etc."
                                    style={{
                                        marginBottom: ".5%",
                                        fontFamily: "sans-serif",
                                    }}
                                    columns="30"
                                    autoSize={true}
                                    setStateValue={setPiePagina}
                                    setStateError={setMensajePiePagina}
                                    valueError={MensajePiePagina}
                                    textError={["Debe escribir un pie de pagina"]}
                                    vacio={false}
                                />

                                <ButtonSingleFile
                                    archivoValue={Logo}
                                    texto={"Adjuntar archivo"}
                                    id="LogoFile"
                                    archivo={setLogo}
                                    formatos={1}
                                    extras={[
                                        "",
                                        "",
                                        "",
                                        setMensajeLogo,
                                    ]}
                                    mensajes={{
                                        "dispatch": dispatch,
                                        "snackbar": showSnackbar,
                                    }}
                                    buttonStyle={{ background: "#F7B369" }}
                                    title="Adjunta tu logo"
                                    buttonClassname="buttonBlue"
                                />
                                <ButtonSingleFile
                                    archivoValue={Firma}
                                    texto={"Adjuntar archivo"}
                                    id="FirmaFile"
                                    archivo={setFirma}
                                    formatos={1}
                                    extras={[
                                        "",
                                        "",
                                        "",
                                        setMensajeFirma,
                                    ]}
                                    mensajes={{
                                        "dispatch": dispatch,
                                        "snackbar": showSnackbar,
                                    }}
                                    buttonStyle={{ background: "#5BC4D2" }}
                                    title="Adjunta tu firma"
                                    buttonClassname="buttonYellow"
                                />
                            </>
                        )}
                        {SecondCheckbox && (
                            <ButtonSingleFile
                                archivoValue={Logo}
                                texto={"Adjuntar archivo"}
                                id="CustomFile"
                                archivo={setLogo}
                                formatos={1}
                                extras={[
                                    "",
                                    "",
                                    "",
                                    setMensajeLogo,
                                ]}
                                mensajes={{
                                    "dispatch": dispatch,
                                    "snackbar": showSnackbar,
                                }}
                                buttonStyle={{ background: "#F7B369" }}
                                title="Adjunta el diseño de tu receta"
                            />
                        )}
                        <div style={{ display: "flex", justifyContent: 'center' }}>
                            <Button
                                className="roundedButtonBlue"
                                style={{ width: "30%", marginTop: "10px" }}
                                loading={loaderSaveConfig}
                                onClick={(e) => saveConfig()}
                            >
                                Guardar
                            </Button>
                        </div>
                    </div>
                </Col>
            </Row>


        </Drawer >
    );
};